import FormFrame from "../FormFrame"
import { testFormSpec } from "./testFormSpec"

export default function TestForm() {
    return <FormFrame spec={testFormSpec} />
}